import React, {useState} from 'react';
import {hooks} from '../hooks';
import {HistoryType} from '../types';
import {components} from '../components';
import { HistoryDetailModal } from './HistoryDetailModal';
  
type Props = {
  index: number;
  history: HistoryType;
  isLast: boolean;
};

export const HistoryItem: React.FC<Props> = ({index, history}) => {
  const navigate = hooks.useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false); 

  const firstPhoto = history.spotDetails
    .flatMap(spot => spot.photos)
    .find(photo => photo) || null;


  return (
    <>
      <div className='history-container'>
        <div 
          key={index} 
          className={`status-${history.status}`}
          style={{
            backgroundColor: 'var(--white-color)', 
            padding: 15, 
            borderRadius: 8, 
            border: '1px solid rgb(133, 221, 227)',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            minHeight:185
            
          }}
          onClick={() => setIsDetailModalOpen(true)}
          onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'}
          onMouseOut={(e) => e.currentTarget.style.boxShadow = 'none'}
        >
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22}}>
            <h3 className='t14 number-of-lines-2' style={{margin: 0, fontWeight: '600', color: 'var(--text-color)', height:42}}>
              {history.patrolName}
            </h3>
            <span 
              className='t10'
              style={{
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: history.status === 'done' ? 'var(--main-turquoise)' : 'var(--accent-color)',
                color: 'white',
                fontWeight: '500'
              }}
            >
              {history.status === 'done' ? 'Selesai' : 'Berlangsung'}
            </span>
          </div>

          <p className='t12 row-center-space-between' style={{marginBottom: 5}}>
            <span className='label' style={{opacity: 0.7}}>Tanggal:</span>
            <span style={{fontWeight: '500'}}>{history.date}</span>
          </p>

          <p className='t12 row-center-space-between clock-in' style={{marginBottom: 8, paddingBottom: 10}}>
            <span className='label' style={{opacity: 0.7}}>Mulai Patrol:</span>
            <span style={{fontSize:'16px', fontWeight: '600', color: 'var(--primary-color)'}}>{history.clockIn}</span>
          </p>  

          {/* 
          <p className='t12 row-center-space-between' style={{marginBottom: 8}}>
            <span className='label' style={{opacity: 0.7}}>Group:</span>
            <span 
              style={{
                fontWeight: '500',
                fontSize: '0.8rem',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '70%'
              }}
            >
              {history.groupName}
            </span>
          </p>

          <p className='t12 row-center-space-between' style={{marginBottom: 12}}>
            <span className='label' style={{opacity: 0.7}}>Spot:</span>
            <span style={{fontWeight: '500'}}>
              {history.completedSpots}/{history.totalSpots} selesai
            </span>
          </p>

          {firstPhoto && (
            <div style={{marginBottom: 12}}>
              <img
                src={firstPhoto}
                alt="Thumbnail patrol"
                style={{ 
              
                  width: '100%', 
                  height: 120, 
                  objectFit: 'cover', 
                  objectPosition: 'center', 
                  borderRadius: 6 
                }}
              />
            </div>
          )}

          <div style={{marginBottom: 8}}>
          </div> */}

          {history.spotDetails.length > 1 && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 0 0 0',
              borderTop: '1px solid var(--border-color)',
              marginTop: 8
            }}>

              <span className='t10' style={{opacity: 0.6}}>
                 Klik untuk detail lengkap
              </span>
            </div>
          )}
        </div>
      </div>
      
      <components.ImageModal
        photos={history.spotDetails.flatMap(spot => spot.photos).filter(photo => photo)}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />

      <HistoryDetailModal
        history={history}
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
      />
    </>
  );
};